/**
 * (c) 2016 Parallax Agency Ltd - http://parall.ax
 **/

/* globals parallax, base, imgix, disqusLoader */

'use strict';

import './components/_polyfills.js';
import skrollr from '../bower_components/skrollr/src/skrollr.js';
import FontFaceObserver from '../bower_components/fontfaceobserver/fontfaceobserver.js';
import imagesLoaded from './components/_imagesloaded.js';
import reframe from '../bower_components/reframe.js/dist/reframe.js';
import loadjs2 from '../bower_components/loadjs/dist/loadjs.umd.js';
import { Tabs } from './components/_accessibility.js';

import { $, $$, clearElementRefs } from './components/_queryselector.js';
import * as _ from './components/_helpers.js';
import * as Forms from './components/_forms.js';
import * as Share from './components/_share.js';
import * as Grid from './components/_grid.js';
import * as Scroll from './components/_scroll.js';
import * as Dropdown from './components/_dropdown.js';
import * as Hero from './components/_hero.js';
import * as Events from './components/_events.js';
import work from './components/_work.js';
import Expose from './components/_expose.js';
import './components/_social_icons.js';
import jsPDFEditor from './jspdf-example.js';

import Loader from './components/_loader.js';

import './components/_disqusloader.js';

window.parallax.Grid = Grid;

let landing = true;
const initialPath = window.location.pathname;

const graphik = new FontFaceObserver('Graphik');
const pressura = new FontFaceObserver('GT-Pressura-Mono');

let jspdfScriptsLoaded = false;

/**
 * Setup any form that is wrapped in the class '.site-form'
 **/

let skrollrRef;
let mobileNavOpen = false;

let $body;
let $navToggle;
let $nav;

const toggleMobileNav = e => {
    if (typeof e !== 'undefined') e.preventDefault();
    $body.classList.toggle('-mobile-nav-active');
    $nav.classList.toggle('-visible');

    if ($navToggle.classList.contains('-active')) {
        $navToggle.classList.remove('-active');
        void $navToggle.offsetWidth;
        $navToggle.classList.add('-out');
        setTimeout(() => {
            $navToggle.classList.remove('-out');
        }, 725);
        mobileNavOpen = false;
    } else {
        $navToggle.classList.add('-active');
        mobileNavOpen = true;
    }
};

/**
 * vars for scroller pages (work and products)
 */
let scrollerOnScroll;
let scrollerOnResize;

const Site = (function() {
    let currentPageName;

    /**
     * Setup packery, but only if it exists
     **/
    const initPackery = () => {
        // setup packery if it's on the page
        let grid = $('.js-grid');

        if (grid && currentPageName !== 'events_index') {
            Grid.init(grid, '.js-grid-item');

            if (currentPageName !== 'events_index') {
                grid.addEventListener('mouseover', e => {
                    if (!e.target.classList.contains('js-grid-inner')) return;

                    const headingHeight = e.target.querySelector('h2')
                        .offsetHeight;
                    e.target.querySelector(
                        '.js-grid-body'
                    ).style.transform = `translate3d(0, -${headingHeight}px, 0)`;
                });

                grid.addEventListener('mouseout', e => {
                    if (!e.target.classList.contains('js-grid-inner')) return;

                    e.target.querySelector('.js-grid-body').style.transform =
                        'translate3d(0, 0, 0)';
                });
            }
        }
    };

    const setupHeading = el => {
        if (parallax.isAdmin) {
            document.body.classList.add('heading-ready');
            return;
        }

        const heading = el;

        if (!heading) return;

        let words;

        function addZeroWidthElems(el) {
            // we expect that el has only one child, a text node: el.firstChild.nodeType === 3
            // split the textNode into an array of words, then remove it from the DOM
            words = el.firstChild.nodeValue.trim().split(/\s+/);
            el.removeChild(el.firstChild);

            // when the zero-width marker elements are created, we will store them on the
            // parent element for easy retrieval
            el.zeroWidthElems = new Array();

            // declare a variable for creating new text nodes
            var newTextNode;

            // loop through the words array, returning each word to the DOM as a textNode
            // followed by marker element.
            for (let i = 0; i < words.length; i++) {
                // return each word into the element, with a space if necessary
                newTextNode = document.createTextNode(
                    (i ? ' ' : '') + words[i]
                );
                el.appendChild(newTextNode);

                // create a zero-width element and store it for later access
                el.zeroWidthElems.push(document.createElement('span'));
                el.zeroWidthElems[i].className = 'zeroWidth';
                el.appendChild(el.zeroWidthElems[i]);
            }
        }

        function forEachTextLine(el, callback) {
            // call the above function to insert zero-width elements (if they haven't been already)
            if (!el.hasOwnProperty('zeroWidthElems')) {
                addZeroWidthElems(el);
            }

            // we will keep track of which line number we are on
            let lineCount = 0;

            // declare variables for calculating element position
            let maxTop = 0;
            let curTop = 0;

            // find the last zeroWidth element
            for (let i = 0; i < el.zeroWidthElems.length; i++) {
                // get the offset relative to the parent element
                curTop = el.zeroWidthElems[i].offsetTop;

                // the first element inspected is automatically the max
                if (i === 0) {
                    maxTop = curTop;
                }

                // if the vertical position is different, the text has wrapped
                if (curTop != maxTop) {
                    // update the maximum
                    maxTop = curTop;

                    // update the line count
                    lineCount++;

                    // do something now that we have found the end of a line
                    callback.call(el, i - 1, lineCount);
                }
                // if this is the last element, it is automatically the end of a line
                else if (i === el.zeroWidthElems.length - 1) {
                    lineCount++;
                    callback.call(el, i, lineCount);
                }
            }

            // return the number of lines in the text node
            return lineCount;
        }

        const endOfLines = [];

        forEachTextLine(heading, a => {
            endOfLines.push(a);
        });

        const lines = [[]];
        let currentLine = 0;
        for (let i = 0; i < words.length; i++) {
            lines[currentLine].push(words[i]);
            if (endOfLines.indexOf(i) !== -1) {
                lines.push([]);
                currentLine++;
            }
        }

        while (heading.hasChildNodes()) {
            heading.removeChild(heading.lastChild);
        }

        for (let i = 0; i < lines.length; i++) {
            if (lines[i].length === 0) continue;
            const div = document.createElement('div');
            const span = document.createElement('span');
            span.textContent = lines[i].join(' ');
            div.appendChild(span);
            heading.appendChild(div);
        }

        heading.addEventListener(
            'animationend',
            _.once(() => {
                const final = heading.innerHTML
                    .replace(/<\/div><div>/g, ' ')
                    .replace(/<div>|<span>|<\/div>|<\/span>/g, '');
                heading.innerHTML = final.trim();
            })
        );

        document.body.classList.add('heading-ready');
    };

    const scrollerPageSetup = page => {
        let initialized = false;
        let enabled = _.windowWidth >= 740;
        const $rootEl = document.querySelector(
            '.js-scroller-page[data-page="' + page + '"]'
        );

        const $scrollerPageScroller = $rootEl.querySelector('.js-scroller');
        const $scrollerPageScrollerList = $rootEl.querySelector(
            '.js-scroller-list'
        );
        const $scrollerPageNav = $rootEl.querySelector('.js-scroller-nav');

        const $navItems = [...$rootEl.querySelectorAll('.js-nav-link')];
        const $scrollerPageItems = [
            ...$rootEl.querySelectorAll('.js-scroller-item'),
        ];

        let activeIndex = -1;
        let itemHeight = $scrollerPageItems[0].offsetHeight;
        let totalHeight = itemHeight * $scrollerPageItems.length;
        let offsetTop = $scrollerPageScrollerList.offsetTop;
        let maxScroll = totalHeight + offsetTop - _.windowHeight;

        let easingEnabled = false;

        const $squiggle = document.querySelector('.js-scroller-page-squiggle');

        scrollerOnResize = () => {
            enabled = _.windowWidth >= 740;
            itemHeight = $scrollerPageItems[0].offsetHeight;
            totalHeight = itemHeight * $scrollerPageItems.length;
            offsetTop = $scrollerPageItems[0].offsetTop;
            maxScroll = totalHeight + offsetTop - _.windowHeight;
            if (initialized) {
                $rootEl.style.height = '';
                requestAnimationFrame(() => {
                    $rootEl.style.height = `${$scrollerPageScrollerList.offsetHeight +
                        $scrollerPageScrollerList.offsetTop}px`;
                });
            }
        };
        window.addEventListener('resize', scrollerOnResize);

        $scrollerPageScroller.addEventListener('mouseenter', () => {
            if (!enabled) return;
            $scrollerPageScroller.classList.add(
                'scroller-page-scroller--expand'
            );
        });
        $scrollerPageScroller.addEventListener('mouseleave', () => {
            if (!enabled) return;
            $scrollerPageScroller.classList.remove(
                'scroller-page-scroller--expand'
            );
        });

        if (enabled) {
            $scrollerPageNav.querySelector('li:last-child').addEventListener(
                'animationend',
                _.once(() => {
                    initialized = true;
                    $rootEl.style.height = `${$rootEl.offsetHeight}px`;
                    $scrollerPageNav.classList.add(
                        'scroller-page-nav--visible'
                    );
                    $scrollerPageScroller.classList.add(
                        'scroller-page-scroller--fixed'
                    );

                    $scrollerPageItems.forEach(el => {
                        imagesLoaded(el, e => {
                            e.elements[0].classList.add(
                                'scroller-page-scroller__item--visible'
                            );
                        });
                    });

                    setActive(0);

                    // squiggle
                    $squiggle.addEventListener('transitionend', e => {
                        if (e.propertyName !== 'transform') return;

                        $squiggle.setAttribute(
                            'data-start',
                            'transform:translate3d(0%,0,0);'
                        );
                        $squiggle.setAttribute(
                            'data-end',
                            'transform:translate3d(-66.6666666%,0,0);'
                        );
                        requestAnimationFrame(() => {
                            skrollrRef.refresh($squiggle);
                        });
                    });

                    //
                    for (let j = 0; j < $scrollerPageItems.length; j++) {
                        imagesLoaded($scrollerPageItems[j], e => {
                            e.elements[0].classList.add('-loaded');
                        });
                    }

                    // bottom of list gets chopped off on scale
                    // so shift the last item details up a bit
                    document.querySelector(
                        '.js-scroller-details-last'
                    ).style.transform = `translateY(-${_.windowHeight *
                        0.05}px)`;
                })
            );
        } else {
            $scrollerPageScroller.classList.add(
                'scroller-page-scroller--fixed'
            );

            $scrollerPageItems.forEach(el => {
                imagesLoaded(el, e => {
                    e.elements[0].classList.add(
                        'scroller-page-scroller__item--visible'
                    );
                    e.elements[0].classList.add('-loaded');
                });
            });
        }

        // Fake hover the nav items whilst you're scrolling each related image
        for (let i = 0; i < $scrollerPageItems.length; i++) {
            const el = $scrollerPageItems[i];
            const $scrollerItemLink = el.querySelector('.js-scroller-link');

            $scrollerItemLink.addEventListener('mouseenter', () => {
                if (!enabled) return;
                setActive(i, true);
            });
        }

        // When you hover over a nav item ensure that others aren't highlighted for any reason
        for (let k = 0; k < $navItems.length; k++) {
            $navItems[k].addEventListener('mouseenter', () => {
                if (!enabled) return;
                if (!easingEnabled) {
                    easingEnabled = true;
                    $scrollerPageScrollerList.style.transition =
                        'transform 1s cubic-bezier(0.860, 0.000, 0.070, 1.000)';
                    $squiggle.style.transition =
                        'transform 1s cubic-bezier(0.42, 0.01, 0.23, 1)';
                }

                let offset =
                    $scrollerPageItems[k].offsetTop +
                    offsetTop -
                    _.windowHeight / 2 +
                    $scrollerPageItems[k].offsetHeight / 2;
                if (offset < 0) offset = 0;

                if (offset > maxScroll) offset = maxScroll;
                $scrollerPageScrollerList.style.transform = `translateY(-${offset}px)`;

                scrollToY(offset);
            });
        }

        let foo = false;

        function scrollToY(y) {
            foo = true;
            window.scrollTo(0, y);
        }

        let last_known_scroll_position = 0;
        let ticking = false;

        // const visibleItems = [];

        function updateOffset(scroll_pos) {
            if (!enabled) return;
            if (easingEnabled && !foo) {
                easingEnabled = false;
                $scrollerPageScrollerList.style.transition = '';
                $squiggle.style.transition = '';
            }

            foo = false;

            $scrollerPageScrollerList.style.transform = `translateY(-${scroll_pos}px)`;

            let index =
                (scroll_pos - offsetTop - itemHeight + _.windowHeight / 2) /
                    itemHeight +
                1;
            index = Math.floor(index);
            setActive(index);
        }

        scrollerOnScroll = () => {
            if (!enabled) return;
            last_known_scroll_position = window.pageYOffset;
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    updateOffset(last_known_scroll_position);
                    ticking = false;
                });
            }
            ticking = true;
        };
        window.addEventListener('scroll', scrollerOnScroll);

        function setActive(index, force = false) {
            if (!enabled) return;
            if (window.pageYOffset >= maxScroll && !force)
                index = $navItems.length - 1;
            if (index === activeIndex) return;
            if (activeIndex >= 0) {
                $navItems[activeIndex].classList.remove('-active');
            }

            activeIndex = index;

            $navItems[index].classList.add('-active');
        }
    };

    // Private functions
    const siteMethods = {
            home: () => {
                if (landing) {
                    document.querySelector('.js-shapes-title').addEventListener(
                        'animationend',
                        _.once(() => {
                            setTimeout(Hero.init, 1000);
                        })
                    );
                } else {
                    const $shapes = document.querySelector('.js-shapes');
                    $shapes.classList.remove('-hidden', '-invisible');

                    Hero.setPaused(false);
                    Hero.init();
                }

                // hero image
                var image = document.querySelector('.js-shapes-image');
                var i = Math.floor(Math.random() * parallax.heroImages.length);
                image.style.backgroundPosition = parallax.heroImages[i][1];

                var img = new Image();
                img.onload = () => {
                    image.style.backgroundImage =
                        'url(' + parallax.heroImages[i][0] + ')';
                    document.body.classList.add('hero-loaded');
                };
                img.src = parallax.heroImages[i][0];
            },

            case_studies_index: () => {
                // scrollerPageSetup('work');
                work();
            },

            products_index: () => {
                scrollerPageSetup('products');
            },

            news_articles_index: () => {
                const grid = $('.js-grid');
                const loadMoreBtn = $('.js-load-more');

                // Convert native dropdowns to non-native, nice looking, accessible ones
                Dropdown.init($('.js-dropdown'), el => {
                    const href = el.href;

                    loadMoreBtn.style.display = 'inline-block';

                    grid.classList.add('-hidden', '-ajaxed'); // -ajaxed tells the CSS to remove the delay on the grid item animation
                    _.get(href, html => {
                        // remove all existing grid items
                        while (grid.firstChild) {
                            grid.removeChild(grid.firstChild);
                        }

                        // add new items
                        const div = document.createElement('div');
                        div.innerHTML = html;
                        const items = $$('.js-grid-item', div);

                        for (let i = 0; i < items.length; i++) {
                            grid.appendChild(items[i]);
                        }

                        grid.classList.remove('-hidden');

                        Grid.layout($$('.js-grid-item')); // layout grid
                        Scroll.attach(grid); // attach scroll watchers

                        const isCategory = href.indexOf('/category/') !== -1;
                        const nextPage = isCategory
                            ? `${href}/page:2`
                            : `${href}/page/2`;

                        if (loadMoreBtn) {
                            loadMoreBtn.setAttribute('href', nextPage);
                        }

                        if (
                            window.history &&
                            window.history.pushState &&
                            !parallax.isAdmin
                        ) {
                            window.history.replaceState(
                                { path: href, title: document.title },
                                '',
                                href
                            );
                        }
                    });
                });

                if (!loadMoreBtn) return;

                // Deal with infinite scroll / load more
                loadMoreBtn.addEventListener('click', e => {
                    if (parallax.isAdmin) return;

                    e.preventDefault();

                    const btn = e.target;
                    btn.setAttribute('disabled', '');

                    const href = btn.getAttribute('href');

                    grid.classList.add('-ajaxed');

                    _.get(href, html => {
                        if (html === 'error404') {
                            btn.removeAttribute('disabled');
                            loadMoreBtn.style.display = 'none';
                            return;
                        }
                        const div = document.createElement('div');
                        div.innerHTML = html;
                        const items = $$('.js-grid-item', div);

                        for (let i = 0; i < items.length; i++) {
                            grid.appendChild(items[i]);
                        }

                        Grid.layout($$('.js-grid-item')); // layout grid

                        // Change focus to first of new elements
                        // let $firstNewElement = items[0].firstChild;
                        // $firstNewElement.focus();

                        Scroll.attach(grid); // attach scroll watchers

                        Scroll.recalcBackgroundSections();
                        Scroll.updateBackground(window.pageYOffset);

                        btn.removeAttribute('disabled');

                        // update href
                        let newHref = href.replace(
                            /\/([0-9]+)$/,
                            (str, pageNum) => {
                                return `/${parseInt(pageNum, 10) + 1}`;
                            }
                        );
                        newHref = newHref.replace(
                            /\/page:([0-9]+)$/,
                            (str, pageNum) => {
                                return `/page:${parseInt(pageNum, 10) + 1}`;
                            }
                        );
                        btn.setAttribute('href', newHref);

                        if (
                            window.history &&
                            window.history.pushState &&
                            !parallax.isAdmin
                        ) {
                            history.replaceState(
                                { path: href, title: document.title },
                                '',
                                href
                            );
                        }
                    });
                });
            },

            news_articles_view: () => {
                Share.init();

                Tabs.addTabIndexToHeadings();

                /**
                 * Add target="_blank" to external links
                 */
                {
                    const links = $$('.js-article a');
                    const hostname = window.location.hostname;
                    for (let i = 0; i < links.length; i++) {
                        if (links[i].hostname !== hostname) {
                            links[i].setAttribute('target', '_blank');
                        }
                    }
                }

                if (!parallax.isAdmin) {
                    reframe('iframe');
                }

                requestAnimationFrame(() => {
                    const $articleProgressContainer = document.querySelector(
                        '.js-progress-bar-container'
                    );
                    const $articleProgress = document.querySelector(
                        '.js-progress-bar'
                    );
                    const $endOfArticle = document.querySelector(
                        '.js-news-share'
                    );
                    let endOfArticleY = $endOfArticle.offsetTop;

                    let visible = false;

                    let lastKnownScrollPosition = 0;
                    let ticking = false;

                    const updateProgress = (scrollPos = 0) => {
                        let percent = (scrollPos / endOfArticleY) * 100;

                        $articleProgress.style.width = `${percent}%`;

                        if ((visible && percent >= 100) || percent === 0) {
                            visible = false;
                            $articleProgressContainer.classList.remove(
                                '-visible'
                            );
                        } else if (!visible && percent < 100) {
                            visible = true;
                            $articleProgressContainer.classList.add('-visible');
                        }
                    };

                    window.addEventListener('scroll', () => {
                        lastKnownScrollPosition = window.pageYOffset;
                        if (!ticking) {
                            window.requestAnimationFrame(() => {
                                updateProgress(lastKnownScrollPosition);
                                ticking = false;
                            });
                        }
                        ticking = true;
                    });
                });

                /**
                 * Load prism to highlight code blocks
                 */
                {
                    const code = $('[class*="language-"]');

                    if (code) {
                        _.loadJS(parallax.prismUrl);
                    }
                }

                /**
                 * Disqus
                 */
                disqusLoader('.disqus', {
                    scriptUrl: 'https://parallax-web.disqus.com/embed.js',
                    laziness: 2,
                    disqusConfig: function() {
                        const matches = window.location.href.match(
                            /\/([0-9]+)\//
                        );
                        this.page.url = `https://parall.ax${
                            window.location.pathname
                        }`;
                        if (typeof matches[1] !== 'undefined') {
                            this.page.identifier = parseInt(matches[1], 10);
                        }

                        this.callbacks.onReady = [
                            function() {
                                Scroll.recalcBackgroundSections();
                                Scroll.updateBackground(window.pageYOffset);
                                setTimeout(() => {
                                    Scroll.recalcBackgroundSections();
                                    Scroll.updateBackground(window.pageYOffset);
                                }, 1000);
                            },
                        ];
                    },
                });
            },

            jspdf: () => {
                // setTimeout(function() {
                //     if (typeof jsPDF == 'undefined') {
                //         document.location.href = '/products/jspdf';
                //     }
                // }, 1000)
                // document.location.href = '/products/jspdf';
                // Forms.initInputs(document.querySelector('.js-form'));

                // document.querySelector('.js-category-filter').addEventListener('click', e => {
                //     const link = e.target.closest('a');
                //     if (!link) return;
                //     e.preventDefault();
                //
                //     // This logic was borrowed from the blog index where the list was full of links rather than
                //     // for changing jsPDF examples. Change as necessary.
                //
                //     const items = document.querySelectorAll('.js-grid-item');
                //     for (let j = 0; j < items.length; j++) {
                //         items[j].classList.remove('-in-view');
                //     }
                // });

                document.body.classList.add('heading-ready');

                if (jspdfScriptsLoaded) {
                    jsPDFEditor.init();
                } else {
                    loadjs2(
                        [
                            'https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.3.2/jspdf.debug.js',
                            'https://cdnjs.cloudflare.com/ajax/libs/ace/1.2.5/ace.js',
                        ],
                        {
                            async: false,
                            success: () => {
                                jspdfScriptsLoaded = true;
                                jsPDFEditor.init();
                            },
                        }
                    );
                }
            },

            expose: () => {
                document.body.classList.add('heading-ready');

                const delay = landing ? 1300 : 400;

                Promise.all([graphik.load(), pressura.load()]).then(
                    () => {
                        setTimeout(Expose().init, delay);
                    },
                    () => {
                        setTimeout(Expose().init, delay);
                    }
                );
            },

            contact: () => {
                // const $contact = document.querySelector('.js-contact');
            },

            events_index: () => {
                Share.init();
                Scroll.eventsNavInit();

                $('.js-shapes-events').classList.remove(
                    '-hidden',
                    '-invisible'
                );

                document.body.classList.add('heading-ready');

                Hero.setPaused(false);
                Hero.init_events();

                const $eventItems = $$('.js-events-item-inner');

                if (!_.isMobile) {
                    for (let i = 0; i < $eventItems.length; i++) {
                        $eventItems[i].addEventListener(
                            'mousemove',
                            Events.shiftText
                        );
                        $eventItems[i].addEventListener(
                            'mouseleave',
                            Events.shiftText
                        );
                        $eventItems[i].addEventListener(
                            'mouseenter',
                            Events.shiftText
                        );
                    }
                }

                const jsSocialOpen = $('.js-social-open');
                const jsSocialClose = $('.js-social-close');
                const jsSocial = $('.js-events-share');
                const jsEventsNav = $('.js-events-nav');

                jsSocialOpen.addEventListener('click', () => {
                    jsSocialOpen.classList.remove('active');
                    jsSocialClose.classList.add('active');
                });

                jsSocialClose.addEventListener('click', () => {
                    jsSocialClose.classList.remove('active');
                    jsSocialOpen.classList.add('active');
                });

                jsSocial.addEventListener('click', () => {
                    jsSocial.classList.toggle('active');
                    jsEventsNav.classList.toggle('active');
                });
            },
        },
        init_contact_form = () => {
            const $contact = document.querySelector('.js-contact');

            Forms.initInputs($contact);

            Forms.ajaxForm($contact, html => {
                if (html === 'sent') {
                    const $form = document.querySelector(
                        '.js-contact .js-form'
                    );

                    const message = document.createElement('p');
                    message.className +=
                        'delta site-form__thanks js-site-form-thanks';
                    message.innerHTML = 'Thanks for your message!';
                    $form.appendChild(message);

                    $('.js-contact .js-form').classList.add('site-form--sent');
                    return;
                }

                $contact.innerHTML = html;
            });
        },
        init_contact = () => {
            const $body = document.body;
            const $contact = document.querySelector('.js-contact');
            const $contactForm = document.querySelector('.js-contact .js-form');
            const $contactInputParents = $contactForm.querySelectorAll(
                '.input'
            );
            const $contactSubmit = $contactForm.querySelector('.submit input');
            const $contactOpen = document.querySelector('.js-contact-open');

            // other buttons that open contact modal
            const $otherButtons = [
                ...document.querySelectorAll('.js-contact-open'),
            ];
            $otherButtons.shift();

            const notContact = document.querySelectorAll(
                '.js-site-main, .js-site-footer, .js-site-header > *:not(.js-contact)'
            );

            const openContact = e => {
                e.preventDefault();
                $contact.classList.add('split-modal--active');
                $contactForm.reset();
                for (let i = 0; i < $contactInputParents.length; i++) {
                    $contactInputParents[i].classList.remove('-is-active');
                }
                $contactSubmit.disabled = false;
                $body.classList.add('-split-modal-active');

                for (let i = 0; i < notContact.length; i++) {
                    //notContact[i].inert = true;
                }
                //$contact.inert = false;
            };

            $contactOpen.addEventListener('click', openContact);

            for (let j = 0; j < $otherButtons.length; j++) {
                $otherButtons[j].addEventListener('click', openContact);
            }

            $contact.addEventListener('click', e => {
                if (!e.target.closest('.js-contact-close')) return;
                e.preventDefault();
                $contact.classList.remove('split-modal--active');
                $contactOpen.classList.add('-visible');
                $body.classList.add('-split-modal-leaving');

                // $contactThanks won't exist until form is submitted, so init it here
                const $contactThanks = document.querySelector(
                    '.js-site-form-thanks'
                );
                if ($contactThanks) {
                    $contactThanks.classList.add('site-form__thanks--hide');
                    $contactThanks.parentNode.removeChild($contactThanks);
                }
                setTimeout(() => {
                    $contactForm.classList.remove('site-form--sent');
                    $body.classList.remove(
                        '-split-modal-active',
                        '-split-modal-leaving'
                    );
                }, 1100);

                for (let i = 0; i < notContact.length; i++) {
                    //notContact[i].inert = false;
                }
                //$contact.inert = true;
            });

            init_contact_form();
        };

    const siteWide = {
        init: () => {
            // Preload SVG needed for loader
            Loader.init();

            // nav toggle
            $body = $('.js-body');
            $navToggle = $('.js-nav-toggle');
            $nav = $('.js-site-nav');
            $navToggle.addEventListener('click', toggleMobileNav);

            /* When something has the js-admin-watch class and the user is in
            admin mode, the page will reload every time the conents of
            js-admin-watch's children changes. At this time this is only used
            on the case studies view when the user changes how many counters
            they want to appear, ensuring it has an immediate effect. */
            if (
                window.parallax.isAdmin &&
                typeof MutationObserver !== 'undefined'
            ) {
                const $adminWatch = $('.js-admin-watch');

                if ($adminWatch) {
                    const observer = new MutationObserver(mutations => {
                        mutations.forEach(mutation => {
                            if (mutation.type === 'childList') {
                                location.reload(false);
                            }
                        });
                    });

                    const observerConfig = {
                        attributes: true,
                        childList: true,
                        subtree: true,
                        characterData: true,
                    };
                    observer.observe($adminWatch, observerConfig);
                }
            }

            //
            _.attachViewportSizeListeners();

            // setup Packery

            if (!window.parallax.isAdmin) {
                initPackery();
            } else {
                setTimeout(() => {
                    initPackery(); // for some reason packery isn't firing late enough in admin
                }, 1000);
            }

            // setup heading
            graphik.load().then(
                () => {
                    const titles = $$('.js-title');
                    for (let i = 0; i < titles.length; i++) {
                        setupHeading(titles[i]);
                    }
                },
                () => {
                    const titles = $$('.js-title');
                    for (let i = 0; i < titles.length; i++) {
                        setupHeading(titles[i]);
                    }
                }
            );

            // footer subscribe form
            {
                const forms = document.querySelectorAll('.js-subscribe');

                for (let i = 0; i < forms.length; i++) {
                    (function(i) {
                        const form = forms[i];
                        const input = form.querySelector('.js-subscribe-input');

                        if (input) {
                            if (input.value !== '') {
                                form.classList.add('-has-text');
                            }

                            input.addEventListener('focus', () => {
                                form.classList.add('-active');
                            });

                            input.addEventListener('blur', () => {
                                form.classList.remove('-active');
                            });

                            input.addEventListener('input', () => {
                                if (input.value === '') {
                                    form.classList.remove('-has-text');
                                } else {
                                    form.classList.add('-has-text');
                                }
                            });
                        }
                    })(i);
                }
            }

            /**
             * scroll watchers
             */
            Scroll.attach();

            /**
             * Contact form
             */
            if (currentPageName === 'contact') {
                init_contact_form();
            } else {
                init_contact();
            }

            /**
             * FontFaceObserver
             */
            {
                if (parallax.isAdmin) {
                    document.body.classList.add('hero-loaded');
                    document.body.classList.add('fonts-loaded');
                } else {
                    // fonts
                    Promise.all([graphik.load(), pressura.load()]).then(
                        () => {
                            document.body.classList.add('fonts-loaded');
                        },
                        () => {
                            document.body.classList.add('fonts-loaded');
                        }
                    );
                }
            }

            /**
             * initialize skrollr (parallax scroll effects)
             */
            if (_.windowWidth >= 768) {
                skrollrRef = skrollr.init({
                    smoothScrolling: false,
                    mobileCheck: () => false,
                });
            }

            // hero image
            if (parallax.pageName !== 'home') {
                document.body.classList.add('hero-loaded');
            }

            // Accessibility
            Tabs.init('4px solid #8b5cdd');
        },
    };

    return {
        // Public functions
        init: pageName => {
            currentPageName = pageName;
        },

        pageLoad: runSiteWide => {
            const propertyName = currentPageName
                .replace(/-/g, '_')
                .toLowerCase();

            if (propertyName !== 'home') {
                document.body.classList.add('hero-loaded');
            }

            if (siteMethods.hasOwnProperty(propertyName)) {
                siteMethods[propertyName]();
            } else {
                // No method set up for this page
                // alert(currentPageName);
            }

            /**
             * Fade in images directly underneath the hero
             */
            {
                const images = $$('.js-fade-image');
                for (let i = 0; i < images.length; i++) {
                    imagesLoaded(images[i], e => {
                        e.elements[0].classList.add('-visible');
                    });
                }
            }

            if (runSiteWide !== false) {
                // Run sitewide functions
                siteWide.init();
            }

            /**
             * Line
             */
            {
                const line = $('.js-line');

                if (line) {
                    const bcr = line.getBoundingClientRect();
                    const middleFromTop =
                        bcr.top + window.pageYOffset + bcr.height / 2;
                    const middleFromBottom = Math.round(
                        _.windowHeight - middleFromTop
                    );

                    if (typeof skrollrRef !== 'undefined') {
                        line.addEventListener(
                            'animationend',
                            _.once(() => {
                                line.setAttribute(
                                    `data--${middleFromBottom}-bottom-center`,
                                    'transform:scaleY(1);opacity:1;'
                                );
                                line.setAttribute(
                                    'data-top-center',
                                    'transform:scaleY(0);opacity:0;'
                                );

                                skrollrRef.refresh(line);
                            })
                        );
                    }
                }
            }
        },

        initPackery,
        setupHeading,
        toggleMobileNav,
    };
})();

let siteMain
let siteFooter
let $shapes

/**
 * Literally just calls the main init function
 * called from the bit below
 **/
const initJavascript = () => {
    siteMain = $('.js-site-main')
    siteFooter = $('.js-site-footer')
    $shapes = $('.js-shapes')

    Site.init(parallax.pageName);
    Site.pageLoad();

    if (window.history && window.history.pushState && !parallax.isAdmin) {
        history.replaceState(
            { path: window.location.pathname, title: document.title },
            ''
        );
    }
};

/**
 * Because we lazy-load the JavaScript,
 * sometimes the document.ready state has already fired,
 * so in that case, check if it's already been fired
 * if it has, init the javascript
 * From: https://plainjs.com/javascript/events/running-code-when-the-document-is-ready-15/
 **/

parallax.ready(initJavascript);

window.addEventListener('click', e => {
    if (!window.history || !window.history.pushState || parallax.isAdmin) {
        return;
    }

    if (e.metaKey || e.ctrlKey || e.shiftKey) return;

    const link = e.target.closest('a');
    if (
        link &&
        link.hostname === window.location.hostname &&
        !link.classList.contains('js-no-hijack') &&
        link.getAttribute('target') !== '_blank' &&
        link.href.indexOf('parall.ax/examples') === -1
    ) {
        e.preventDefault();
        goToPage(link.pathname);
    }
});

if (window.history && window.history.pushState && !parallax.isAdmin) {
    window.addEventListener('popstate', e => {
        if (!e.state || !e.state.path) {
            if (window.location.pathname !== initialPath) {
                goToPage(initialPath, false);
                return;
            }
            return;
        }
        goToPage(e.state.path, false);
    });
}

const goToPage = (path = '/', push = true) => {
    // update nav current page marker
    const currentNavItem = $('.js-site-nav .-current');
    if (currentNavItem) {
        currentNavItem.classList.remove('-current');
    }

    const newNavItem = $(`.js-site-nav [data-path="${path}"]`);
    if (newNavItem) {
        newNavItem.classList.add('-current');
    }

    Scroll.setBackgroundPaused(true);

    setTimeout(() => {
        clearElementRefs();
        Scroll.destroy();
        if (typeof skrollrRef !== 'undefined') {
            skrollrRef.destroy();
        }
        Grid.destroy();

        window.removeEventListener('resize', scrollerOnResize);
        window.removeEventListener('scroll', scrollerOnScroll);

        if (siteFooter == null) {
            document.location.href = '/';
        }
        document.body.style.height = '';
        while (siteMain.hasChildNodes()) {
            siteMain.removeChild(siteMain.lastChild);
        }

        landing = false;
        document.body.classList.remove('landing');
        document.body.classList.remove('heading-ready');
        document.body.classList.remove('hero-loaded');

        Scroll.setNavHidden(false);
        $nav.classList.remove('-in-h', '-out-h', '-in-v', '-out-v');

        window.scrollTo(0, 0);

        _.get(`${path}?fullpage=true`, (data, res) => {
            if (data == 'error404') {
                // goToPage('/errors/error404', true);
                // This 404s too for some reason

                // Redirect for now as short on time before release
                window.location.href = base + 'errors/error404';
            } else {
                // update page title
                if (res.getResponseHeader('X-Expose-title')) {
                    document.title = _.decodeEntities(
                        res.getResponseHeader('X-Expose-title')
                    );
                }

                // update address bar
                if (push) {
                    if (res.getResponseHeader('X-Expose-path')) {
                        path = res.getResponseHeader('X-Expose-path');
                    }
                    history.pushState(
                        { path, title: document.title },
                        '',
                        path
                    );
                }

                siteMain.innerHTML = data;
                requestAnimationFrame(() => {
                    document.body.classList.remove('-page-loading');

                    Loader.stop();

                    if (res.getResponseHeader('X-Expose-page')) {
                        parallax.pageName = res.getResponseHeader(
                            'X-Expose-page'
                        );
                        Site.init(parallax.pageName);
                        Site.pageLoad(false); // run page function, but not site wide functions (already run)
                    } else {
                        parallax.pageName = '';
                    }

                    const hideFooter =
                        // parallax.pageName === 'case_studies_index' ||
                        parallax.pageName === 'products_index';
                    if (hideFooter) {
                        siteFooter.style.display = 'none';
                    } else {
                        siteFooter.style.display = 'block';
                    }

                    Scroll.recalcBackgroundSections(true);
                    Scroll.updateBackground();

                    if (res.getResponseHeader('X-Expose-page')) {
                        document.body.classList.add(
                            `body--${parallax.pageName}`
                        );
                    }

                    if (typeof imgix !== 'undefined') {
                        imgix.init();
                    }

                    Scroll.setBackgroundPaused(false);

                    Site.initPackery();

                    const titles = $$('.js-title');
                    for (let o = 0; o < titles.length; o++) {
                        Site.setupHeading(titles[o]);
                    }

                    Scroll.attach();

                    if (typeof skrollrRef !== 'undefined') {
                        skrollrRef = skrollr.init({
                            smoothScrolling: false,
                            mobileCheck: () => false,
                        });
                    }
                });
            }
        });
    }, 600);

    if (mobileNavOpen) {
        siteMain.style.transitionDuration = '0s';
        toggleMobileNav();
    }

    Loader.start();
    document.body.classList.add('-page-loading');

    if (parallax.pageName === 'home') {
        $shapes.addEventListener(
            'transitionend',
            _.once(() => {
                Hero.setPaused(true);
            })
        );
        $shapes.style.transitionDelay = '0s';
        $shapes.classList.add('-invisible');
    }
};



// WEBPACK FOOTER //
// ./assets/js/main.js